import { Tab } from '@quickbit/backoffice-core-frontend';
import { IconName } from '@quickbit/qb-design-system';
import { Permissions } from '../constants';
import { Accounting } from './Accounting';
import { Payments } from './Accounting/Payments';
import { Reports } from './Accounting/Reports';
import { AffiliateUsers } from './AffiliateUsers';
import { AgentChat } from './AgentChat';
import { AlgorandProcessing } from './AlgorandProcessing';
import { AppUsers } from './AppUsers';
import {
  PagoraQuickbitDashboard,
  TransactionRequests,
  Users,
} from './DirectOnramp';
import { Cases } from './FCU/Cases';
import { ChainalysisLookup } from './FCU/ChainalysisLookup';
import { Cm1Archive } from './FCU/Cm1Archive';
import { ManualReview } from './FCU/ManualReview';
import { Statistics } from './FCU/Statistics';
import { FrozenAssets } from './FrozenAssets';
import { MerchantOrders } from './MerchantOrders';
import { MerchantRefunds } from './MerchantRefunds';
import { Merchants } from './Merchants';
import { SkinningUsers, Sites as SkinningSites } from './NewSkinning';
import { OrderStatistics } from './OrderStatistics';
import { Platforms } from './Platforms';
import { ProcessingUsers } from './ProcessingUsers';
import { RulesEngine } from './RulesEngine';
import { SkinningCustomers } from './SkinningCustomers';
import { Transactions } from './Transactions';
import { Wallets } from './Wallets';

export const tabsData: Tab[] = [
  {
    name: 'Platforms',
    icon: 'building',
    component: <Platforms />,
    requiredPermissions: [Permissions.VIEW_MERCHANTS],
  },
  {
    name: 'Merchants',
    icon: 'building',
    component: <Merchants />,
    requiredPermissions: [Permissions.VIEW_MERCHANTS],
  },
  {
    name: 'Users',
    icon: 'profile',
    component: null,
    requiredPermissions: [Permissions.VIEW_QB_USERS],
    subTabs: [
      {
        name: 'App',
        icon: 'profile',
        component: <AppUsers />,
        requiredPermissions: [Permissions.VIEW_QB_USERS],
      },
      {
        name: 'Skinning',
        icon: 'profile',
        component: <SkinningCustomers />,
        requiredPermissions: [Permissions.VIEW_QB_USERS],
      },
      {
        name: 'Affiliate',
        icon: 'profile',
        component: <AffiliateUsers />,
        requiredPermissions: [Permissions.VIEW_QB_USERS],
      },
      {
        name: 'Processing',
        icon: 'profile',
        component: <ProcessingUsers />,
        requiredPermissions: [Permissions.VIEW_QB_USERS],
      },
    ],
  },
  {
    name: 'Merchant Orders',
    icon: 'list',
    component: <MerchantOrders />,
    requiredPermissions: [Permissions.VIEW_MERCHANT_ORDERS],
  },

  {
    name: 'Direct Onramp',
    icon: 'list' as IconName,
    component: null,
    requiredPermissions: [Permissions.VIEW_MERCHANT_ORDERS],
    subTabs: [
      {
        name: 'Transaction Requests',
        icon: 'list' as IconName,
        component: <TransactionRequests />,
        requiredPermissions: [Permissions.VIEW_MERCHANT_ORDERS],
      },
      {
        name: 'Pagora/Quickbit Dashboard',
        icon: 'list' as IconName,
        component: <PagoraQuickbitDashboard />,
        requiredPermissions: [Permissions.VIEW_MERCHANT_ORDERS],
      },
      {
        name: 'Users',
        icon: 'profile' as IconName,
        component: <Users />,
        requiredPermissions: [Permissions.VIEW_MERCHANT_ORDERS],
      },
    ],
  },
  {
    name: 'Algorand processing',
    icon: 'list' as IconName,
    component: <AlgorandProcessing />,
    requiredPermissions: [Permissions.VIEW_MERCHANT_ORDERS],
  },
  {
    name: 'New Skinning',
    icon: 'scan' as IconName,
    component: null,
    requiredPermissions: [Permissions.VIEW_MERCHANT_ORDERS],
    subTabs: [
      {
        name: 'Users',
        icon: 'profile' as IconName,
        component: <SkinningUsers />,
        requiredPermissions: [Permissions.VIEW_QB_USERS],
      },
      {
        name: 'Sites',
        icon: 'list' as IconName,
        component: <SkinningSites />,
        requiredPermissions: [Permissions.VIEW_QB_USERS],
      },
    ],
  },
  {
    name: 'Merchant Refunds',
    icon: 'send',
    component: <MerchantRefunds />,
    requiredPermissions: [Permissions.VIEW_MERCHANT_ORDERS],
  },
  {
    name: 'Order Statistics',
    icon: 'earn',
    component: <OrderStatistics />,
    requiredPermissions: [Permissions.VIEW_MERCHANT_ORDERS],
  },
  {
    name: 'Transactions',
    icon: 'wallet',
    component: <Transactions />,
    requiredPermissions: [Permissions.VIEW_QB_USERS],
  },
  {
    name: 'Wallets',
    icon: 'wallet',
    component: <Wallets />,
    requiredPermissions: [Permissions.VIEW_QB_USERS],
  },
  {
    name: 'Frozen Assets',
    icon: 'freeze',
    component: <FrozenAssets />,
    requiredPermissions: [Permissions.VIEW_QB_USERS],
  },
  {
    name: 'Accounting',
    icon: 'document',
    component: null,
    requiredPermissions: [Permissions.VIEW_SETTLEMENT_REPORT],
    subTabs: [
      {
        name: 'Generate',
        icon: 'document',
        component: <Accounting />,
        requiredPermissions: [Permissions.VIEW_SETTLEMENT_REPORT],
      },
      {
        name: 'Reports',
        icon: 'list',
        component: <Reports />,
        requiredPermissions: [Permissions.VIEW_SETTLEMENT_REPORT],
      },
      {
        name: 'Payments',
        icon: 'wallet',
        component: <Payments />,
        requiredPermissions: [Permissions.VIEW_SETTLEMENT_REPORT],
      },
    ],
  },
  {
    name: 'FCU',
    icon: 'security',
    component: null,
    requiredPermissions: [Permissions.VIEW_QB_USERS],
    subTabs: [
      {
        name: 'Manual Review',
        icon: 'security',
        component: <ManualReview />,
        requiredPermissions: [Permissions.VIEW_QB_USERS],
      },
      {
        name: 'Cases',
        icon: 'list',
        component: <Cases />,
        requiredPermissions: [
          [Permissions.VIEW_FCU_INFO],
          [Permissions.DEVELOPER],
        ],
      },
      {
        name: 'CM1 Archive',
        icon: 'search',
        component: <Cm1Archive />,
        requiredPermissions: [Permissions.VIEW_FCU_INFO],
      },
      {
        name: 'Rules Engine',
        icon: 'filter',
        component: <RulesEngine />,
        requiredPermissions: [Permissions.VIEW_QB_USERS],
      },
      {
        name: 'Statistics',
        icon: 'stats',
        component: <Statistics />,
        requiredPermissions: [
          [Permissions.VIEW_FCU_INFO],
          [Permissions.DEVELOPER],
        ],
      },
      {
        name: 'Chainalysis Lookup',
        icon: 'search',
        component: <ChainalysisLookup />,
        requiredPermissions: [
          [Permissions.VIEW_FCU_INFO],
          [Permissions.DEVELOPER],
        ],
      },
    ],
  },
  {
    name: 'Agent Chat',
    icon: 'community',
    component: <AgentChat />,
    requiredPermissions: [Permissions.VIEW_QB_USERS],
  },
];
